import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {FiltersContext} from "../../../context/FiltersContext";
import {getInboxApi} from "../services/HomeServices";
import DashboardKpiPendentiView from "./DashboardKpiPendentiView";
import {AuthContext} from "../../../context/AuthContext";

export default function DashboardKpiPendentiController() {

    const [loadingData, setLoadingData] = useState(true);
    const [info, setInfo] = useState([]);

    const {updateFiltroKpi} = useContext(FiltersContext);
    const {annoKpi} = useContext(AuthContext);

    const history = useHistory();

    async function getInbox() {
        const response = await getInboxApi();
        setInfo(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        if (annoKpi) {
            getInbox();
        }
    }, [annoKpi]);

    function onClickStatoBozza() {
        updateFiltroKpi('id_stato_kpi', '1'); // TODO recuperare id attraverso il codice 'BZ'
        history.push('/list-kpi')
    }

    function onClickStatoCompleto() {
        updateFiltroKpi('id_stato_kpi', '2'); // TODO recuperare id attraverso il codice 'CP'
        history.push('/list-kpi')
    }

    function onClickStatoApprovato() {
        updateFiltroKpi('id_stato_kpi', '3'); // TODO recuperare id attraverso il codice 'AP'
        history.push('/list-kpi')
    }

    return (
        /* Disegno solo se sono presenti dati */
        !loadingData && info &&
        <DashboardKpiPendentiView
            info={info}
            onClickStatoBozza={onClickStatoBozza}
            onClickStatoCompleto={onClickStatoCompleto}
            onClickStatoApprovato={onClickStatoApprovato}
        />
    );
}